module.exports = __webpack_public_path__ + "static/media/products.e0afe220.png";